import FixPaymentAction from '@/classes/SubmissionActions/FixPaymentAction'
import { BaseEverplansStatus } from '@/classes/SubmissionStatuses/BaseEverplansStatus'
import { StatusThemeVariant } from '@/classes/SubmissionStatuses/StatusThemeVariantEnum'
import { type SubmissionAction } from '@/classes/SubmissionStatuses/types'

export default class PaymentError extends BaseEverplansStatus {
	getActions(): Array<SubmissionAction> {
		return [
			new FixPaymentAction(
				this.submissionStatus.paymentAmount // emailFailed confirms emailStatus is set
			),
		]
	}

	getStatusText() {
		return 'Invalid Payment'
	}

	getToolTipText() {
		return {
			title: this.getVendorName() + ' ' + this.getStatusText(),
			body: 'There are issues with the payment method. Click Fix button to update it. Have questions? Contact salesstudio@precoa.com.',
		}
	}

	getThemeVariant() {
		return StatusThemeVariant.ERROR
	}
}
